import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projectsDatascience = [
    {
      title: "Animal Classification",
      description: "Convolutional Neural Network",
      imgUrl: projImg1,
    },
    {
      title: "Age & Gender Detection",
      description: "Deep Learning",
      imgUrl: projImg2,
    },
    {
      title: "Noble Metals Price Predection",
      description: "LSTM",
      imgUrl: projImg3,
    },
  ];
  const projectsWebdev = [
    {
      title: "Free-Focused",
      description: "Screen-time tracker and Task management browser extension",
      imgUrl: projImg1,
    },
    // {
    //   title: "Age & Gender Detection",
    //   description: "Deep Learning",
    //   imgUrl: projImg2,
    // },
    // {
    //   title: "Noble Metals Price Predection",
    //   description: "LSTM",
    //   imgUrl: projImg3,
    // },
  ];
  const projectsPersonal = [
    {
      title: "NGO",
      description: "Served needy people",
      imgUrl: projImg1,
    },
    // {
    //   title: "Age & Gender Detection",
    //   description: "Deep Learning",
    //   imgUrl: projImg2,
    // },
    // {
    //   title: "Noble Metals Price Predection",
    //   description: "LSTM",
    //   imgUrl: projImg3,
    // },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Data Science</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Web Developmenet</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Personal</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projectsDatascience.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          projectsWebdev.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <Row>
                        {
                          projectsPersonal.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                   
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
